import {
  createBrowserRouter,
  Navigate,
  type RouteObject,
} from "react-router";
import App from "../App";
import Splash from "../components/views/splash/Splash";
import IncidentGrowth from "../components/views/incident-growth/IncidentGrowth";
import CostsBreakdown from "../components/views/costs-breakdown/CostsBreakdown";
import RiskCalc from "../components/views/risk-calc/RiskCalc";
// import Assessments from "../components/views/assessments/Assessments";
import PeerPurchasing from "../components/views/peer-purchasing/PeerPurchasing";
import CyberGlossary from "../components/views/cyber-glossary/CyberGlossary";
import CookiePolicy from "../components/views/cookie-policy/CookiePolicy";
// import TestView from "../components/views/TestView";
// import TermsConditions from "../components/views/TermsConditions";
import ErrorPage from "../components/views/ErrorPage";

// import { store } from "../store/store";
import { routeLoader } from "../routes/routeLoader";

// Redux helpers
// const dispatch = store.dispatch;

// Define the routes using `createBrowserRouter`
const routes = createBrowserRouter([
  {
    path: "/",
    element: <App />, // App acts as the layout
    errorElement: <ErrorPage />,
    children: [
      {
          index: true,
          element: <Navigate to="/splash" replace />
      },
      {
          path: "splash",
          element: <Splash />,
          loader: routeLoader
      },
      {
          path: "incident-growth",
          element: <IncidentGrowth />,
          loader: routeLoader
      },
      {
          path: "costs-breakdown",
          element: <CostsBreakdown />,
          loader: routeLoader
      },
      {
          path: "cyber-risk-calculators",
          element: <RiskCalc />,
          loader: routeLoader
      },
      // {
      //     path: "assessments",
      //     element: <Assessments />,
      //     loader: routeLoader
      // },
      {
          path: "peer-purchasing-insights",
          element: <PeerPurchasing />,
          loader: routeLoader
      },
      {
          path: "cyber-library",
          element: <CyberGlossary />,
          loader: routeLoader
      },
      {
          path: "cookie-policy",
          element: <CookiePolicy />,
          loader: routeLoader
      },
      // {
      //     path: "test-view",
      //     element: <TestView />,
      //     loader: routeLoader
      // },
      // {
      //     path: "terms-and-conditions",
      //     element: <TermsConditions />,
      //     loader: routeLoader
      // },
      {
          path: "*",
          element: <Navigate to="/splash" replace />
      }
  ]
  },
],
{
  basename: import.meta.env.VITE_BASE || '/', // Base path for the application
});

export default routes;